// =============================================================================
// Copyright   : 2018 semantics GmbH
// Date        : $Date: 2026-01-31 22:57:43 +0100 (Sat, 31 Jan 2026) $
// Author      : Dirk Rothe, Tobias Schwarzkopf
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 160223 $
// Purpose     : templating system for uix
// =============================================================================
// ---Third-party imports
// ---Framework imports
import { createAction, GENERATOR, COPY2PAYLOAD, SILENT } from 'uix/actions';
// integrate payload into root/data/parts/*
// maybe put action create ts in meta
export const setFilterData = createAction('SET_FILTER_DATA', COPY2PAYLOAD);
// activate new runId
// activate filterData (data.newParts -> data.part) for view
// we derive a activateView call from ROUTER_LOCATION_CHANGED via redux middleware (and pass router information)
export const activateView = createAction('ACTIVATE_VIEW', (runId, router)=>({
        runId,
        router
    }));
// reload filters of given part
// also reload useApi calls that have a partReloadable=true option
// part is partName || partType
export const reloadPartFilters = createAction('RELOAD_PART_FILTERS', (part)=>({
        part
    }));
// reload all parts of view
export const reloadAllParts = createAction('RELOAD_All_PARTS');
export const loadStandalonePart = createAction('LOAD_STANDALONE_PART', (name, partStoreKey, dname, partcfg, runId)=>({
        name,
        partStoreKey,
        dname,
        partcfg,
        runId
    }));
export const setPartLoaded = createAction('SET_PART_LOADED', (name, partStoreKey, runId)=>({
        name,
        partStoreKey,
        runId
    }));
export const updateThemeVariable = createAction('UPDATE_THEME_VAR', (name, value)=>({
        name,
        value
    }));
export const switchTheme = createAction('SWITCH_THEME', (name)=>({
        name
    }));
// L131Split layout
export const persistSplitter = createAction('PERSIST_SPLITTER', (componentName, splitName, size)=>({
        componentName,
        splitName,
        size
    }), SILENT);
export const setDomainCSS = createAction('SET_DOMAIN_CSS', (dcss)=>({
        dcss
    }), SILENT);
export const setElementBounds = createAction('SET_ELEMENT_BOUNDS', (key, bounds)=>({
        key,
        bounds
    }), SILENT);
export const measureParts = createAction('MEASURE_PARTS', (reason)=>({
        reason
    }));
export const setLoadedChunks = createAction('SET_LOADED_CHUNKS', (names)=>({
        names
    }));
